'use strict';

var toastr = require('toastr');
var ContributingFBCsGridController = function ContributingFBCsGridController($scope, contributingFBCsGridService, faresAverageGridService, $log) {
  function successSavingHandler() {
    $scope.$broadcast('fares-contributing-fbcs-grid:saveSuccess');
    $scope.$broadcast('grid:dataChanged');
    toastr.success('Data was saved successfully');
  }
  function errorSavingHandler(error) {
    var message = error.data && error.data.message || error.statusText || error.message;
    $log.error('ContributingFBCsGridController: errorSavingHandler - ' + message);
    toastr.error(message);
  }
  $scope.saveFares = function (event, rowsToSave) {
    if (rowsToSave.length > 0) {
      if (isSavedDataValid(rowsToSave)) {
        contributingFBCsGridService.save(rowsToSave).then(successSavingHandler, errorSavingHandler);
      } else {
        $log.error('ContributingFBCsGridController: saveFares - Saved value is invalid');
        toastr.error('Saved value is invalid');
      }
    }
  };
  function isSavedDataValid(rowsToSave) {
    var isValid = true;
    rowsToSave.forEach(function (row) {
      if (row.userTraffic < 0) {
        isValid = false;
        return;
      }
    });
    return isValid;
  }
};
ContributingFBCsGridController.$inject = ['$scope', 'ContributingFBCsGridService', 'FaresAverageGridService', '$log'];
module.exports = ContributingFBCsGridController;